import React from 'react';
 
import I18n from 'i18n-react';
 
function ClearAllFilters(props) {
 
 const { clearFilters } = props;
 
 return (
 <button className="ta-filter-clear" onClick={clearFilters}>
 <span>{I18n.translate('filters.clearAllFilters')}</span>
 <i className="icon-close"></i>
 </button>
 );
}
 
export default ClearAllFilters;


// WEBPACK FOOTER //
// ./src/components/flightSelection/filters/clearAllFilters/ClearAllFilters.jsx